import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import '../../../recruit/common/Recruit.scss';
import './MinisterInfo.scss';
import { loginStateAtom } from '../../../../AtomStore';
import { USER_TYPE_ONBOARDING_PATH } from '../../../login/userTypeUtils';

// 비로그인 사용자가 사역자정보 항목을 눌렀을 때 오는 안내 페이지 — 이력서·자기소개서·포트폴리오 작성 유도
const STEPS = [
  {
    title: '이력서',
    description: '학력·경력·희망사항을 정리해 교회 담당자에게 나를 소개하는 기본 정보입니다.',
    items: ['인적사항과 증명사진', '학력 · 사역 경력', '희망 유형 · 지역 · 부서'],
  },
  {
    title: '자기소개서',
    description: '소명과 사역 비전을 나의 언어로 전해 교회와 마음이 맞는지 알려주세요.',
    items: ['소명과 신앙고백', '사역 경험과 강점', '사역 철학과 비전'],
  },
  {
    title: '사역 포트폴리오',
    description: '실제 사역 모습을 보여주면 교회 담당자의 관심을 더 받을 수 있어요.',
    items: ['설교영상', '찬양영상', '사역사진'],
  },
];

export default function MinisterWriteGuide() {
  const navigate = useNavigate();
  const isLogin = useAtomValue(loginStateAtom);

  const go = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="recruit minister-info">
      <div className="inner">
        <div className="subpage__main">
          <div className="subpage__main__title">
            <h3>사역자정보 등록</h3>
          </div>

          <section className="minister-info__write">
            <div className="minister-info__write-hero">
              <h4>이력서 · 자기소개서 · 포트폴리오를 작성해보세요</h4>
              <p>
                교회 담당자들이 사역자정보에서 함께할 사역자를 찾고 있습니다.<br />
                나를 소개하는 자료를 작성하면 교회 담당자에게 먼저 연락받을 수 있어요.
              </p>
            </div>

            <ol className="minister-info__write-steps">
              {STEPS.map((step, index) => (
                <li key={step.title} className="minister-info__write-step">
                  <div className="minister-info__resume-guide-num">{index + 1}</div>
                  <div className="minister-info__write-body">
                    <h5>{step.title}</h5>
                    <p>{step.description}</p>
                    <ul>
                      {step.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
              ))}
            </ol>

            <div className="minister-info__write-privacy">
              <b>개인정보는 이렇게 보호됩니다</b>
              <ul>
                <li>목록에는 이름 일부만 표시되고, 사진은 모자이크 처리됩니다.</li>
                <li>연락처와 상세주소는 목록에 노출되지 않습니다.</li>
                <li>작성한 내용은 마이페이지에서 언제든 수정·삭제할 수 있습니다.</li>
              </ul>
            </div>

            <div className="minister-info__write-actions">
              {isLogin ? (
                <button type="button" className="minister-info__guard-btn" onClick={() => go('/mypage/resumeedit')}>
                  이력서 작성하기
                </button>
              ) : (
                <>
                  <button type="button" className="minister-info__guard-btn" onClick={() => go('/login')}>
                    로그인하고 작성하기
                  </button>
                  <button
                    type="button"
                    className="minister-info__write-sub"
                    onClick={() => {
                      navigate(USER_TYPE_ONBOARDING_PATH, { state: { signupFlow: true } });
                      window.scrollTo(0, 0);
                    }}
                  >
                    회원가입
                  </button>
                </>
              )}
            </div>

            <div className="minister-info__resume-guide-foot">
              <button type="button" onClick={() => go('/minister')}>사역자정보 목록으로</button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
